import { createFileRoute } from "@tanstack/react-router";

import { type ChildRouteContext } from "@/root";
import {
  redirectIfModuleDisabled,
  throwIfHasNoPermission,
} from "@/utils/permissions";

import RecognitionSettingsForm from "../../../components/settings/RecognitionSettingsForm";

export const Route = createFileRoute(
  "/admin/_panel/_settings/settings/recognition",
)({
  component: RouteComponent,
  beforeLoad: ({ context }) => {
    redirectIfModuleDisabled("recognition", context.tenant.modules);

    throwIfHasNoPermission(
      context.user,
      "recognition.recognition-settings.view",
    );

    return {} satisfies ChildRouteContext;
  },
});

function RouteComponent() {
  return <RecognitionSettingsForm />;
}
